<template>
  <div class="box6">
    <pageTitle
      title="多种适学人群 职业路径明确"
      text="拒绝盲目摸索，帮你构建鸿蒙晋级之路"
      titleColor="#000D4D"
      titColor="#5A628A"
    />

    <div class="subject-content">
      <div class="wrap">
        <div class="title">适学人群</div>
        <div class="content">
          <div class="item-wrapper" v-for="(item, index) in list" :key="index">
            <div class="img">
              <img :src="item.img" alt="" />
            </div>
            <div class="cont">
              <div class="tit">{{ item.tit }}</div>
              <p class="desc">{{ item.txt }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="load-title">鸿蒙开发职业发展路径</div>
      <div class="bottom-box">
        <div class="bottom-title">职业发展路径明确  掘金鸿蒙未来可期</div>
        <div class="bottomImg"></div>
      </div>
      <div class="btn" @click="zixun">了解职业发展</div>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
export default {
  components: {
    pageTitle,
  },
  mounted() {},
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/harmony/box6/1.png"),
          tit: "学历/年龄没有优势？ 明智选鸿蒙",
          txt: "统招大专及以上学历、计算机专业学生，通过学习鸿蒙新兴技术，入行互联网、物联网，高起点就业。",
        },
        {
          img: require("../../../assets/coursePage/harmony/box6/2.png"),
          tit: "前端开发遇到瓶颈？ 果断转鸿蒙",
          txt: "在就业、转行等方面存在压力与瓶颈的前端开发人员，学习鸿蒙技术拓宽就业范围，抓住时代风口，为自己加薪。",
        },
        {
          img: require("../../../assets/coursePage/harmony/box6/3.png"),
          tit: "Android/iOS 日渐式微？ 闭眼入鸿蒙",
          txt: "安卓、苹果应用开发日渐式微，学习鸿蒙技术提前入局新方向，凭借自身应用开发经验，做鸿蒙赛道的抢手人才。",
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("鸿蒙-就业课","了解职业发展",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box6 {
  padding: 80px 0 88px;
  width: 100%;
  background: url("../../../assets/coursePage/harmony/box6/bg.png") no-repeat;
  background-size: cover;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: flex-start;
  font-family: PingFang SC;
  .pagetitle {
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    text-align: center;
  }
  .subject-content {
    margin-top: 59px;
    .bottomImg {
      width: 612px;
      height: 525px;
      margin: 60px auto 50px;
      background: url("../../../assets/coursePage/harmony/box6/bottom-pic.png")
        no-repeat;
      background-size: cover;
    }
    .wrap {
      .title {
        box-sizing: border-box;
        margin: 0 auto;
        padding: 25px 0 0 113px;
        width: 276px;
        height: 75px;
        background: url("../../../assets/coursePage/harmony/box6/title-bg1.png");
        background-size: cover;
        font-size: 32px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #000D4C;
        line-height: 32px;
      }
      .content {
        margin-top: 52px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        .item-wrapper{
          position: relative;
          .img{          
            position: absolute;
            top: 30px;
            left: 30px;
            img{
              width: 150px;
              height: 150px;
              background: #FFF6EA;
              box-shadow: 0 0 30px 0 #CCD5FF;
              border-radius: 20px;
              border: 2px solid #FFFFFF;
            }
          }
          .cont{
            box-sizing: border-box;
            width: 660px;
            height: 210px;
            padding: 34px 30px 0 150px;
            margin: 0 0 30px 60px;
            background: #FFFFFF;
            border-radius: 30px;
            .tit{
              height: 26px;
              margin-bottom: 14px;
              font-weight: 600;
              font-size: 26px;
              line-height: 26px;
              color: #000D4D;
            }
            .desc{
              font-size: 24px;
              color: #474D66;
              line-height: 36px;
            }
          }
        }
      }
    }
    .load-title {
      box-sizing: border-box;
      margin: 33px auto 0;
      padding: 25px 0 0 113px;
      width: 474px;
      height: 74px;
      background: url("../../../assets/coursePage/harmony/box6/title-bg2.png");
      background-size: cover;
      font-size: 32px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #000D4C;
      line-height: 32px;
    }
    .bottom-box {
      margin: 50px auto 0;
      width: 690px;
      height: 719px;
      background: #FFFFFF;
      border-radius: 30px;
      box-sizing: border-box;
      padding-top: 50px;
      .bottom-title {
        font-weight: 600;
        font-size: 36px;
        color: #000D4D;
        line-height: 36px;
        text-align: center;
      }
    }
  }
  .btn {
    margin: 50px auto 0;
    width: 570px;
    height: 88px;
    background: linear-gradient(0deg, #FF6C47 1%, #FF5A47 100%);
    border-radius: 44px;
    font-weight: 600;
    font-size: 30px;
    color: #FFFFFF;
    line-height: 88px;
    text-align: center;
  }
}
</style>
